import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Element } from 'react-scroll';
import { AuctionResultsIcon, ExternalLinkIcon, OnlineAuctionIcon, PinIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, Card, Heading, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import CalendarButton from './calendar-button';
import * as styles from './auction.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AUCTION_FORMAT = 'dddd D MMMM, h:mma';
var Auction = _ref => {
  var auction = _ref.auction,
    auctionsRestricted = _ref.auctionsRestricted,
    listing = _ref.listing,
    onlineAuctionInfoLink = _ref.onlineAuctionInfoLink,
    onOnlineAuctionInfoClick = _ref.onOnlineAuctionInfoClick,
    onRegisterForAuctionClick = _ref.onRegisterForAuctionClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var venue = auction.venue;
  if (!venue) {
    if (auction.hasOnlineAuction) {
      venue = 'Online';
    } else {
      venue = auctionsRestricted ? 'Contact agent for location' : 'On site';
    }
  }
  var onAuctionCalendarDownload = () => {
    sendEvent('auction-calendar-click');
  };
  var onGoToOnlineAuction = () => {
    sendEvent('online-auction-click');
  };
  return ___EmotionJSX("section", {
    "aria-label": "auction"
  }, ___EmotionJSX(Element, {
    name: "online-auction"
  }), ___EmotionJSX(Heading, {
    title: "Auction"
  }), auction.startTime && ___EmotionJSX("div", {
    css: styles.details,
    "data-testid": "auction-details"
  }, ___EmotionJSX(AuctionResultsIcon, {
    css: styles.icon
  }), ___EmotionJSX("span", {
    css: styles.text
  }, moment(auction.startTime).format(AUCTION_FORMAT)), ___EmotionJSX(CalendarButton, {
    title: "Auction",
    startTime: auction.startTime,
    listing: listing,
    location: auction.venue,
    onClick: onAuctionCalendarDownload
  })), ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX(PinIcon, {
    css: styles.icon
  }), ___EmotionJSX("span", {
    css: styles.text
  }, auction.venue)), auction.hasOnlineAuction && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX(OnlineAuctionIcon, {
    css: styles.icon
  }), ___EmotionJSX("span", {
    css: styles.text
  }, "Online auction available")), ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.onlineHeading
  }, "Can't attend the auction in person?", ' ', ___EmotionJSX("span", {
    css: styles.goOnline
  }, "Go online.")), ___EmotionJSX("p", {
    css: styles.onlineText
  }, auction.auctionUrl ? 'Find out more details about the online auction for this property and how to pre-register.' : 'Please contact the agent to pre-register for the online auction, understand how it will be conducted and how to be an active bidder.'), auction.auctionUrl ? ___EmotionJSX(LinkButton, {
    css: styles.button,
    appearance: "secondaryNeutral",
    iconPosition: "right",
    icon: ___EmotionJSX(ExternalLinkIcon, null),
    href: auction.auctionUrl,
    onClick: onGoToOnlineAuction,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Register to bid") : ___EmotionJSX(Button, {
    css: styles.button,
    appearance: "secondaryNeutral",
    onClick: onRegisterForAuctionClick
  }, "Contact agent")), ___EmotionJSX(Card, {
    css: styles.onlineCard,
    action: "Learn more",
    onClick: onOnlineAuctionInfoClick,
    href: onlineAuctionInfoLink
  }, ___EmotionJSX("div", {
    css: styles.cardTitle
  }, "How do online auctions work?"), ___EmotionJSX("p", {
    css: styles.cardMessage
  }, "Online auctions differ from traditional on-site auctions in a couple of ways."))));
};
Auction.propTypes = {
  listing: PropTypes.shape({}).isRequired,
  auction: PropTypes.shape({
    hasOnlineAuction: PropTypes.bool,
    venue: PropTypes.string,
    startTime: PropTypes.string,
    auctionUrl: PropTypes.string
  }).isRequired,
  auctionsRestricted: PropTypes.bool,
  onlineAuctionInfoLink: PropTypes.string,
  onOnlineAuctionInfoClick: PropTypes.func,
  onRegisterForAuctionClick: PropTypes.func
};
Auction.defaultProps = {
  auctionsRestricted: false,
  onlineAuctionInfoLink: 'https://www.allhomes.com.au/advice/how-do-online-auctions-work-944249/',
  onOnlineAuctionInfoClick: () => {},
  onRegisterForAuctionClick: () => {}
};
export default Auction;